import { generateClient } from 'aws-amplify/api';

export async function updateInformation(vendorId, changedFields) {
    const client = generateClient();

    let input = {
        id: vendorId,
    };

    Object.keys(changedFields).forEach(key => {
        input[key] = changedFields[key];
    });

    try {
        const response = await client.graphql({
            query: `
            mutation MyMutation($input: UpdateVendorInput!) {
                updateVendor(input: $input) {
                        company_name
                        address
                        vendor_bio
                        contact_name
                        contact_email
                        contact_phone_number
                        website
                        year_founded
                        number_of_employees
                        service_description
                        service_specialties
                        has_api_interest
                        serve_plan
                        revenue
                        title
                        id
                        approval_status
                        is_active
                        is_chic_participant
                        date_approved
                        date_registered
                        vendor_comments
                        last_status_update
                        application_viewed
                }
            }
            `,
            variables: {
                input: input,
            },
            authMode: 'userPool',
        });
        return response.data.updateVendor;
    } catch (error) {
        return error;
    }
}

export async function updateProductInformation(productId, changedFields) {
    console.log("changedFields", changedFields);
    const client = generateClient();

    let input = {
        id: productId,
    };

    Object.keys(changedFields).forEach(key => {
        input[key] = changedFields[key];
    });
    try {
        const updateProduct = await client.graphql({
            query: `
            mutation MyMutation($input: UpdateProductInput!) {
                updateProduct(input: $input) {
                banner
                categories {
                        id
                }
                contact_email
                created_at
                description
                essential_redirect
                facebook
                features
                has_free_trial
                has_free_version
                id
                images
                instagram
                is_chic_participant
                is_essential
                is_published
                linkedin
                name
                pricing
                privacy_policy
                thumbnail
                twitter
                updated_at
                vendor {
                    id
                    company_name
                }
                videos
                website
                }
            }
            `,
            variables: {
                input: input,
            },
            authMode: 'userPool',
        });
        console.log("updateProduct", updateProduct.data.updateProduct);
        return updateProduct.data.updateProduct;
    } catch (error) {
        console.error("Error updating product data:", error);
        return null;
    }
}

export async function fetchVendors() {
    const client = generateClient();

    try {
        const retrieveVendors = await client.graphql({
            query: `
            query MyQuery {
                vendors {
                    company_name
                    address
                    vendor_bio
                    contact_name
                    contact_email
                    contact_phone_number
                    website
                    year_founded
                    number_of_employees
                    service_description
                    service_specialties
                    has_api_interest
                    serve_plan
                    revenue
                    title
                    id
                    approval_status
                    is_active
                    is_chic_participant
                    date_approved
                    date_registered
                    created_at
                    updated_at
                    vendor_comments
                    last_status_update
                    application_viewed
                }
            }
        `,
            authMode: 'userPool',
        });
        return retrieveVendors.data.vendors;
    } catch (error) {
        console.error("Error fetching vendor data:", error);
    }
}


export async function fetchProducts() {
    const client = generateClient();
    try {
        const retrieveProducts = await client.graphql({
            query: `
           query MyQuery {
            products(filter: {}) {
                banner
                categories {
                        id
                }
                contact_email
                created_at
                description
                essential_redirect
                facebook
                features
                has_free_trial
                has_free_version
                id
                images
                instagram
                is_chic_participant
                is_essential
                is_published
                linkedin
                name
                pricing
                privacy_policy
                thumbnail
                twitter
                updated_at
                vendor {
                    id
                    company_name
                }
                videos
                website
            }
            }
        `,
            authMode: 'userPool',
        });

        return retrieveProducts.data.products;
        // const sortedProducts = retrieveProducts.data.products.sort((a, b) => a.id - b.id);

    } catch (error) {
        console.error("Error fetching product data:", error);
    }
}